/* eslint-disable */
document.addEventListener('DOMContentLoaded', function(event) {
  document.addEventListener('click', event => {
    if (event?.target?.className?.includes('repair-cat-name')) {
      // jQuery('.repair-cat-name').removeClass('active')
      // jQuery(this).addClass('active')
      // setTimeout(function() {
      //   jQuery('.repair-sub-name-set')
      //     .children('br')
      //     .remove()
      // }, 200)
      jQuery('.repair-cat-name').removeClass('active')
      jQuery(event.target).addClass('active')
      var tabIndex = jQuery(event.target).index()
      var searchBlock = jQuery(event.target).closest('.repair-sheet')
      searchBlock.find('.repair-sub-models').removeClass('active')
      searchBlock
        .find('.repair-sub-models')
        .eq(tabIndex)
        .addClass('active')
    }
    if (event.target.className.includes('repair-sub-model-name')) {
      jQuery(event.target)
        .parent()
        .find('.repair-sub-model-name')
        .removeClass('active')
      jQuery(event.target).addClass('active')
      var tabIndex = jQuery(event.target).index()
      var searchBlock = jQuery(event.target)
        .closest('.repair-sub-names-wrap')
        .siblings('.repair-services')
      var searchContent = searchBlock.find('.repair-service-model-block')
      searchBlock.find('.repair-service-model-block').removeClass('active')
      searchBlock
        .find('.repair-service-model-block')
        .eq(tabIndex)
        .addClass('active')
    }
  })
  // jQuery('.repair-cat-name').click(function() {
  //   jQuery('.repair-cat-name').removeClass('active')
  //   jQuery(this).addClass('active')
  // })
  // setTimeout(function() {
  //   jQuery('.repair-sub-name-set')
  //     .children('br')
  //     .remove()
  // }, 200)
  // jQuery('.repair-cat-name').click(function() {
  //   jQuery('.repair-cat-name').removeClass('active')
  //   jQuery(this).addClass('active')
  //   var tabIndex = jQuery(this).index()
  //   var searchBlock = jQuery(this).closest('.repair-sheet')
  //   searchBlock.find('.repair-sub-models').removeClass('active')
  //   searchBlock
  //     .find('.repair-sub-models')
  //     .eq(tabIndex)
  //     .addClass('active')
  // })
  // jQuery('.repair-sub-model-name').click(function() {
  //   jQuery(this)
  //     .parent()
  //     .find('.repair-sub-model-name')
  //     .removeClass('active')
  //   jQuery(this).addClass('active')
  //   var tabIndex = jQuery(this).index()
  //   var searchBlock = jQuery(this)
  //     .closest('.repair-sub-names-wrap')
  //     .siblings('.repair-services')
  //   var searchContent = searchBlock.find('.repair-service-model-block')
  //   searchBlock.find('.repair-service-model-block').removeClass('active')
  //   searchBlock
  //     .find('.repair-service-model-block')
  //     .eq(tabIndex)
  //     .addClass('active')
  // })
})
// window.onload = () => {
// }
// jQuery(window).ready(function() {
// })
